import React from "react";
// left side
// import { LeaderBox } from "./LeaderBox";
import { PalettePicker } from "./PalettePicker"
// import { ScratchThumbnailCarousel } from "./ThumbnailCarousel";
import { ReactItemsThumbnailCarousel as ThumbnailCarousel } from "./ThumbnailCarousel";
import { PrintRecord } from "../../../BlakeData/Types";

import "./style/main.scss";

/**
 * The left side of the group page
 * @param props 
 */
export function LeftSide(props: {
    width: number;
    showMicropalette?: boolean;
    prints: Array<PrintRecord>;
    selectedPrints: Array<number>;
    setSelectedPrints: (p: Array<number>) => void;
    groupID: string;
    compareMode: boolean;
}) {

    const maxItems = props.compareMode ? 2 : 1;
    const toggleItem = (i: number) => {
        let selected = props.selectedPrints;

        let newArray = selected.slice();
        const idx = newArray.indexOf(i);
        const adding = (idx < 0);


        if (adding) {

            // if we are adding a new item, do this stuff...

            // add item to end of array
            newArray = [i].concat(newArray);

            // remove extra items
            props.setSelectedPrints(newArray.slice(0, maxItems));


        } else {

            // drop the item 
            let newArray = selected.slice();
            newArray.splice(idx, 1)
            props.setSelectedPrints(newArray);

        }

    }

    return (
        <div className="LeftSide">
            {props.showMicropalette ? <PalettePicker
                width={props.width / 2}
                groupID={props.groupID}
                prints={props.prints}
            /> : (null)}

            <div className="Carousel">
                <ThumbnailCarousel
                    width={props.width}
                    prints={props.prints}
                    maxItems={2}
                    onChange={(selected: Array<number>) => {
                        props.setSelectedPrints(selected);
                    }}
                    onToggleItem={toggleItem}
                    selected={props.selectedPrints}
                />
            </div>



            {/* <LeaderBox
                maxItems={2}
                selectedPrints={props.prints ? props.selectedPrints.map((idx: number) => {
                    return props.prints[idx]
                }) : []}
            /> */}

        </div>
    );


}